var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0227 0H2.70455C1.21328 0 0 1.21328 0 2.70455V14.2955C0 15.7867 1.21328 17 2.70455 17H22.0227C23.514 17 24.7273 15.7867 24.7273 14.2955V2.70455C24.7273 1.21328 23.514 0 22.0227 0ZM2.70455 1.54545H22.0227C22.6618 1.54545 23.1818 2.06545 23.1818 2.70455V4.25H1.54545V2.70455C1.54545 2.06545 2.06545 1.54545 2.70455 1.54545ZM22.0227 15.4545H2.70455C2.06545 15.4545 1.54545 14.9345 1.54545 14.2955V5.79545H23.1818V14.2955C23.1818 14.9345 22.6618 15.4545 22.0227 15.4545Z",
    fill: "#505050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40922 13.1365H4.6365C4.20976 13.1365 3.86377 12.7906 3.86377 12.3638V11.5911C3.86377 11.1643 4.20976 10.8184 4.6365 10.8184H5.40922C5.83596 10.8184 6.18195 11.1643 6.18195 11.5911V12.3638C6.18195 12.7906 5.83596 13.1365 5.40922 13.1365Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/credit-card-icon.a8eb1e9621d7a7d0abee2cb463386ce2.svg";
export { ForwardRef as ReactComponent };